import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';
import { ALL_YEARS } from '../document-data/document-data.data';
import { Schedule } from '../document-data/sub-models/schedule.model';
import { List } from 'immutable';

export const PAID_LIST_SEARCH_PARAMS = 'paid_invoice_list_search_params';
export const UNPAID_LIST_SEARCH_PARAMS = 'unpaid_invoice_list_search_params';

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.doc_date,
  sort_order: SortOrderEnum.desc,
  document_tax_year: ALL_YEARS,
});

export const DEFAULT_PAID_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.date_paid,
  sort_order: SortOrderEnum.desc,
  document_tax_year: ALL_YEARS,
});

export enum InvoiceFiltersEnum {
  paid = 'paid',
  unpaid = 'unpaid',
}

export interface IScheduleResponse {
  schedules: List<Schedule>;
  deletedIds: List<string>;
}
